import { render, staticRenderFns } from "./report-project-documents.vue?vue&type=template&id=075f8445"
import script from "./report-project-documents.vue?vue&type=script&lang=js"
export * from "./report-project-documents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports